import http from "./http";

const getEmpoyee = () => {
  return http.get(`/drivers/drivers`);
};

const login = (data) => {
  return http.post("/users/login", data);
};

const uploadDriverClothes = (file) => {
  const formData = new FormData();
  formData.append("file", file);

  return http.post("/drivers/driver-cloth", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

const getDailyPhotos = (
  date_start = new Date().toISOString().split("T")[0],
  date_end = new Date().toISOString().split("T")[0]
) => {
  return http.get(`/drivers/cloth`, {
    params: { date_start, date_end },
  });
};

export default {
  getEmpoyee,
  login,
  uploadDriverClothes,
  getDailyPhotos,
};
